import styled from 'styled-components';

export const SubL3CategoriesStyled = styled.div`
  .containerL3 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${(props) => (props.width ? '50px' : '25px')};
    width: 780px;
    padding: 5px;
    position: absolute;
    left: ${(props) => (props.width ? '25px' : `calc(50% - 484px / 2)`)};
    background: #ffffff;
    z-index: 2;
    top: 24px;
    right: 0;
    margin-left: 19px;
  }
  .categorySection {
    display: flex;
    flex-direction: column;
    width: 450px;
    border-right: ${(props) => (props.width ? `1px solid var(--light-theme-card-border-color, #e3e9ef)` : '')};
  }
  .brandSection {
    display: flex;
    flex-direction: column;
    width: 340px;
  }

  .categoriesDetails {
    display: flex;
    flex-direction: row;
    width: auto;
    height: auto;
    flex-wrap: wrap;
  }
  .carouselContainer {
    padding: 0px 6px 6px 4px;
  }
  .l3Title {
    position: relative;
    left: 7px;
    height: 19px;
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 700;
    font-size: 11px;
    line-height: 19px;
    text-transform: uppercase;
    color: #031a32;
  }
  .catImage {
    flex-wrap: wrap;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 83px;
    height: 83px;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #e3e9ef;
    border-radius: 8px;
    gap: 10px;
    margin: 10px;
  }
  .catTitle {
    width: 100px;
    height: auto;
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    text-align: center;
    color: #031a32;
    align-self: stretch;
  }
  .brandCarousel {
    padding: 2px;
  }
  .brandDetails {
    display: flex;
    flex-direction: row;
    width: auto;
    height: auto;
    flex-wrap: wrap;
  }
  .brandTitle {
    position: relative;
    height: 19px;
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 700;
    font-size: 11px;
    line-height: 19px;
    text-transform: uppercase;
    color: #031a32;
  }
  
  &.rtl {
    .containerL3 {
      left: 0;
      right: ${(props) => (props.width ? '25px' : `calc(50% - 484px / 2)`)};
      margin-left: 0px;
      margin-right: 19px;
      .l3Title {
        left: auto;
        right: 7px;
      }
    }
  }
`;
